var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarcodeImg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 24,
    viewBox: "0 0 109 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6H3V18H2V6ZM4 6H6V18H4V6ZM8 6H9V18H8V6ZM10 6H13V18H10V6ZM14 6H15V18H14V6ZM17 6H18V18H17V6ZM19 6H20V18H19V6ZM21 6H22V18H21V6Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 6H24V18H23V6ZM25 6H27V18H25V6ZM29 6H30V18H29V6ZM31 6H34V18H31V6ZM35 6H36V18H35V6ZM38 6H39V18H38V6ZM40 6H41V18H40V6ZM42 6H43V18H42V6Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45 6H46V18H45V6ZM47 6H49V18H47V6ZM51 6H52V18H51V6ZM53 6H56V18H53V6ZM57 6H58V18H57V6ZM60 6H61V18H60V6ZM62 6H63V18H62V6ZM64 6H65V18H64V6Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66 6H67V18H66V6ZM68 6H70V18H68V6ZM72 6H73V18H72V6ZM74 6H77V18H74V6ZM78 6H79V18H78V6ZM81 6H82V18H81V6ZM83 6H84V18H83V6ZM85 6H86V18H85V6Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87 6H88V18H87V6ZM89 6H91V18H89V6ZM93 6H94V18H93V6ZM95 6H98V18H95V6ZM99 6H100V18H99V6ZM102 6H103V18H102V6ZM104 6H105V18H104V6ZM106 6H107V18H106V6Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcodeImg);
export default __webpack_public_path__ + "static/media/barcode-img.cf0f5ee3aec4b13dca85c1a54f63f8e3.svg";
export { ForwardRef as ReactComponent };